import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const INTERNAL_PORTAL_ID = 137828;
export const INTERNAL_PORTAL_ID_QA = 885765335;
export const isInternalPortal = (portalId = PortalIdParser.getPortalIdFromPath()) => portalId === (enviro.isQa() ? INTERNAL_PORTAL_ID_QA : INTERNAL_PORTAL_ID);
export const ExternalPortalOnly = ({
  portalId = PortalIdParser.getPortalIdFromPath(),
  fallback,
  children
}) => /*#__PURE__*/_jsx(_Fragment, {
  children: isInternalPortal(portalId) ? fallback : children
});
export default ExternalPortalOnly;